import { MessageCircle } from "lucide-react";

const NUMBERS = [
  { label: "+54 3821 452181", wa: "543821452181", testid: "topbar-wa-1" },
  { label: "+54 3821 450522", wa: "543821450522", testid: "topbar-wa-2" },
];
const MSG = encodeURIComponent("Hola! Quiero atención personalizada y precios más baratos");

export default function TopBar() {
  return (
    <div data-testid="top-bar" className="bg-gradient-to-r from-[#ff4500] via-[#ff6a00] to-[#ff4500] text-black">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 py-1.5 flex flex-col sm:flex-row items-center justify-center gap-1.5 sm:gap-4">
        <span className="text-[11px] sm:text-xs font-bold tracking-wider uppercase text-center">
          Atención personalizada y precios más baratos
        </span>
        <div className="flex gap-2">
          {NUMBERS.map((n) => (
            <a
              key={n.wa}
              href={`https://wa.me/${n.wa}?text=${MSG}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={n.testid}
              className="flex items-center gap-1.5 rounded-full bg-black text-white px-3 py-1 text-[11px] sm:text-xs font-semibold hover:bg-[#111] hover:scale-[1.03]"
              style={{ transition: "transform 160ms ease, background-color 160ms ease" }}
            >
              <MessageCircle className="w-3.5 h-3.5 text-emerald-400" /> {n.label}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
